import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading, SubsectionHeading } from 'web-ui-components/lib/typography/headings';

import withContent from '../../../containers/withContent';
import copContent from '../Content/cop.content';

function GenericError({
	content: { okButtonText, genericErrorHeader, genericErrorFooter },
	errorDetails,
	errorMessage,
	onPrimary,
}) {
	return (
		<ServicingSection>
			<PageHeading data-test-id="generic-error">{genericErrorHeader}</PageHeading>
			<StandardBody>
				<p>{errorMessage || errorDetails?.response?.coded_exceptions?.[0].error_status}</p>
			</StandardBody>
			<SubsectionHeading>{genericErrorFooter}</SubsectionHeading>
			<NavigationButtonGroup
				primaryButton={
					<NavigationButton.Primary
						labelText={okButtonText}
						onClick={onPrimary}
						data-test-id={'cop-generic-error-primary-button'}
					/>
				}
			/>
		</ServicingSection>
	);
}

GenericError.propTypes = {
	content: PropTypes.shape({
		genericErrorHeader: PropTypes.string,
		genericErrorFooter: PropTypes.string,
		okButtonText: PropTypes.string,
	}).isRequired,
	errorDetails: PropTypes.shape({
		response: PropTypes.shape({
			coded_exceptions: PropTypes.arrayOf(
				PropTypes.shape({ error_status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
			),
		}),
	}),
	errorMessage: PropTypes.string,
	onPrimary: PropTypes.func.isRequired,
};

const GenericErrorWithContent = withContent({ content: copContent })(GenericError);

export { GenericErrorWithContent as GenericError };
